module.exports = __webpack_public_path__ + "img/empty.e04d29f9.png";